/*
 * Purpose : Component to have main routing paths
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

//import React, { Component, lazy } from "react";
import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { Switch, Route, BrowserRouter } from "react-router-dom";

import Aux from "./../hoc/Auxilliary/Auxilliary";
import Header from "./../components/header/header";
import Footer from "../components/UI/footer/footer";
import Home from "../components/home/home";
//const Home = lazy(() => import('./routes/Home'));
import Transactions from "../components/Transactions/Transactions";
import InputForm from "../components/InputForm/InputForm";
import ViewForm from "../components/ViewForm/ViewForm";
import NotFound from "./../components/notFound/notFound";
import Help from "../components/help/help";
import Setup from './Setup/SetupHome';
import UserManagement from "./Setup/UserManagement/UserManagement";
import Locations from "./Setup/Locations/Locations";
import Dashboard from "./Dashboard";
import RetirementSalesFormHome from '../components/retirementSalesForm/RetirementSalesFormHome'
import ToolSalesFormHome from '../components/ToolSalesForm/ToolSalesFormHome'
import BrokerConfig from './Setup/BrokerConfig/BrokerConfig';
import ToolSalesInputForm from '../components/ToolSalesForm/InputForm/ToolSalesInputForm'
import ToolSalesTransactions from '../components/ToolSalesForm/Transactions/ToolSalesTransactions'
import AppLogs from "../components/dashboard/AppLogs";
import AppContext from "../context/app-context";
import "./../css/form.css";
import "./../App.css";
import BgImage from "../../src/assets/bg01.png";
import ToolSalesView from "../components/ToolSalesForm/ToolSalesView/ToolSalesView";
class ExcessEquipmentMain extends Component {
  static contextType = AppContext;
  render() {
    console.log("rendered")
    return (
      <Aux>
        <div style={{ backgroundImage: `url(${BgImage})` }}>
          {/* <Header username={this.context.user.toLowerCase()} home={true} /> */}
          <BrowserRouter>
            <Switch>
              <Route
                path="/home"
                render={

                  () => <>
                          <Header username={this.context.user.toLowerCase()} home={true} />
                          <Home user={this.context.user.toLowerCase()} />
                        </>
              }
              />
              <Route
                path="/"
                exact={true}
                render={
                  () => <>
                          <Header username={this.context.user.toLowerCase()} home={true} />
                          <Home user={this.context.user.toLowerCase()} />
                        </>

                }
              />
              <Route
                path="/retirementform"
                exact
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <RetirementSalesFormHome user={this.context.user.toLowerCase()} />
                              </>
                  
                }
                //component={RetirementSalesFormHome}
              />
              <Route
                path="/toolsalesform"
                exact
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <ToolSalesFormHome user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/toolsales/transactions"
                exact
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <ToolSalesTransactions user={this.context.user.toLowerCase()} />
                              </>    
                }
              />              
              <Route
                path="/transactions"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <Transactions user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/form"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <InputForm user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route 
                path="/help"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <Help user={this.context.user} />
                              </>    
                }
              />
              <Route
                path="/viewform/:transid"
                render={(props) => <>
                                <Header {...props} username={this.context.user.toLowerCase()} home={true} />
                                <ViewForm {...props} user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/setup"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <Setup user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/usermgt"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <UserManagement user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/locations"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <Locations user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/brokers"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <BrokerConfig user={this.context.user.toLowerCase()} />
                              </>    
                }
              />              
              <Route
                path="/dashboard"
                exact
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <Dashboard user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/dashboard/logs"
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <AppLogs user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/editexcesstoolform/:transid"
                render={(props) => <>
                                <Header username={this.context.user.toLowerCase()} {...props} home={true} />
                                <InputForm user={this.context.user.toLowerCase()} {...props} />
                              </>    
                }
              />
              <Route
                path="/toolsales/form"
                exact
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <ToolSalesInputForm user={this.context.user.toLowerCase()} />
                              </>    
                }
              />
              <Route
                path="/toolsales/editform/:transid"
                exact
                render={(props) => <>
                                <Header username={this.context.user.toLowerCase()} {...props} home={true} />
                                <ToolSalesInputForm user={this.context.user.toLowerCase()} {...props} />
                              </>    
                }
              />
              <Route
                path="/toolsales/viewform/:transid"
                exact
                render={(props) => <>
                                <Header username={this.context.user.toLowerCase()} {...props} home={true} />
                                <ToolSalesView user={this.context.user.toLowerCase()} {...props} />
                              </>    
                }
              />
              <Route
                render={() => <>
                                <Header username={this.context.user.toLowerCase()} home={true} />
                                <NotFound />
                              </>    
                }
              />
            </Switch>
          </BrowserRouter>
          <Footer />
        </div>
      </Aux>
    );
  }
}

export default ExcessEquipmentMain;
